import React from 'react';
import EntityGraph from './entityGraph';
import EventGraph from './eventGraph';
import relevance from '../img/relevance.png';
import {Select, Slider, Spin} from 'antd';
import background from "../img/background.jpg";
import logo from "../img/logo.png";
import Relationship from "./relationship";

const {Option} = Select;

export default class Portrait extends React.Component {

    render() {
        const {
            coOccurrenceMaxCount, coOccurrenceThreshold, dailyList, selectIndex, loading,
            showRelevance, nodeCount, timeList, events, eventRelations, entities, newsIdMap,
            selectedEntities, unSelectedEntities, selectedEntitiesEdges, unSelectedEntitiesEdges,
            entitySelected, eventSelected, selectDate, showRelevanceButton, countSliderChange, thresholdSliderChange
        } = this.props;

        let newsCount = 0;
        events.forEach(event => {
            newsCount += event['articleId'].length;
        });

        let options = [];
        dailyList.forEach((item, index) => {
            options.push(<Option key={index} value={index}>{item}</Option>)
        });

        return <div id={'main'} style={{
            width: '100vw',
            height: '100vh',
            minWidth: 1024,
            minHeight: 768,
        }}>
            <img
                src={background}
                style={{
                    width: '100vw',
                    height: '100vh',
                    position: 'absolute'
                }}
                alt={'background'}
            />

            <div style={{
                zIndex: 1,
                position: 'fixed',
                left: 0,
                right: 0,
                top: 0,
                height: 60,
                background: '#19424A'
            }}>
                <img style={{
                    marginLeft: 15,
                    marginTop: 10,
                    marginRight: 15,
                }} onClick={()=>window.location.href='https://www.newsminer.net/'} src={logo} width={150} height={30} alt={'NewsMiner'}/>
                <span style={{
                    color: '#ffffff',
                    verticalAlign: 'text-top',
                    fontSize: 25,
                    width: 500,
                    height: 25
                }}>
                    疫情日报
                </span>
                <label style={{
                    color: '#ffffff',
                    float: 'right'
                }}>
                    共
                    {events.length}
                    个事件，
                    包含
                    {newsCount}
                    篇新闻
                </label>
            </div>
            <Spin
                tip={'加载中'}
                size={'large'}
                spinning={loading}
            >
                <div id={'page-container'} style={{height: '100vh', width: '100vw'}}>
                    <EntityGraph entities={entities} width={1200} height={800} events={events} newsIdMap={newsIdMap}
                                 selectedEntitiesEdges={selectedEntitiesEdges}
                                 unSelectedEntitiesEdges={unSelectedEntitiesEdges}
                                 selectedEntities={selectedEntities}
                                 unSelectedEntities={unSelectedEntities}
                                 showRelevance={showRelevance}
                                 entitySelected={entitySelected}/>
                    <EventGraph events={events} timeList={timeList} eventSelected={eventSelected}
                                eventRelations={eventRelations}/>
                    <Relationship events={events}/>
                    <Select
                        onSelect={selectDate}
                        defaultValue={selectIndex}
                        style={{
                            width: 220,
                            position: 'absolute',
                            left: 35,
                            top: 100
                        }}
                    >
                        {options}
                    </Select>

                    <div onClick={showRelevanceButton}
                         className={'tool-button'}
                         style={{
                             position: 'absolute',
                             left: '40vw',
                             top: '88vh',
                         }}>
                        <img src={relevance} className={'tool-icon'} alt={'相关度调节按钮'}/>
                    </div>
                    {showRelevance && entities.length > 0 ?
                        <div>
                            <Slider defaultValue={nodeCount}
                                    max={entities.length}
                                    onAfterChange={countSliderChange}
                                    style={{
                                        position: 'absolute',
                                        left: '37vw',
                                        top: '83vh',
                                        width: 190,
                                        height: 30,
                                    }}/>
                            <Slider defaultValue={coOccurrenceThreshold}
                                    min={5}
                                    max={coOccurrenceMaxCount}
                                    onAfterChange={thresholdSliderChange}
                                    style={{
                                        position: 'absolute',
                                        left: '37vw',
                                        top: '80vh',
                                        width: 190,
                                        height: 30,
                                    }}/>
                        </div> : null}
                </div>
            </Spin>
        </div>
    }
}
